// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__HLSdZ","title":"BackImages_title__10pqm","images":"BackImages_images__2y-lV"};